export default [
    {
        path: '/introduction',
        name: 'app.introduction',
        component: () => import(/* webpackChunkName: "home" */ '@/pages/[organisation]/home/introduction.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
    {
        path: '/whatsnew',
        name: 'app.whatsnew',
        component: () => import(/* webpackChunkName: "home" */ '@/pages/[organisation]/home/whats-new.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
    {
        path: '/home',
        name: 'app.home',
        component: () => import(/* webpackChunkName: "home" */ '@/pages/[organisation]/home/index.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
    {
        path: '/:organisation/menu',
        component: () => import(/* webpackChunkName: "home" */ '@/pages/[organisation]/home/application-menu.vue'),
        name: 'app.menu',
        meta: {
            guestRequired: false,
            loginRequired: true,
            contentArea: true,
            permission: '*',
        },
    },
    {
        path: '/:organisation/start',
        component: () => import(/* webpackChunkName: "home" */ '@/pages/[organisation]/home/start.vue'),
        name: 'app.start',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
];
